import React from 'react';
import PropTypes from 'prop-types';
import {observable, reaction} from 'mobx';
import {inject, observer} from 'mobx-react';
import {locationShape, routerShape, withRouter} from 'react-router';

import {withConfig, withI18n} from 'spa/Components/Context';
import {cn} from 'spa/css';

import CartWithCountButton from '../../Pages/BookingNext/Components/CartWithCountButton';

import basketIcon from 'spa/images/icons/cart-18.svg';

@withRouter
@inject(({
  store: {
    basketNew,
    tracker,
  },
}) => ({
  basketNew,
  tracker,
}))
@observer
@withConfig
@withI18n
class HeaderBasketSectionWrapper extends React.Component {
  static propTypes = {
    basketNew: PropTypes.shape({
      basketFormattedAddress: PropTypes.string,
      basketHasAddress: PropTypes.bool,
      basketHasStartsAt: PropTypes.bool,
      basketHasWorker: PropTypes.bool,
      basketServiceCount: PropTypes.number,
      getBasketSummary: PropTypes.func.isRequired,
    }).isRequired,
    location: locationShape.isRequired,
    onOpenBasketPanel: PropTypes.func.isRequired,
    router: routerShape.isRequired,
    basketItems: PropTypes.object,
    userLoggedIn: PropTypes.bool,
    tracker: PropTypes.object.isRequired,
  };

  constructor(props, context) {
    super(props);

    const {i18n} = context;
    const {location} = props;

    // At the moment we only want to show the new basket button in the homepage
    // This will be updated as we update the entrypoints to point at the new flow
    this.isUnifiedBasket = location.pathname === `/${i18n.lc}/` ||
      location.pathname.split('/').indexOf('lp5') !== -1 ||
      location.pathname.split('/').indexOf('treatments') !== -1;
  }

  componentDidMount() {
    const {i18n} = this.context;
    const {
      basketNew,
      userLoggedIn,
    } = this.props;

    this.listeners = [
      reaction(
        () => [
          this.isUnifiedBasket,
          userLoggedIn,
        ],
        () => {
          if (this.isUnifiedBasket) {
            basketNew.getBasketSummary()
              .catch((err) => {
                if (__DEV__) {
                  console.error(err);
                }
              });
          }
        },
        {
          name: 'Request basket summary if is the homepage',
          compareStructural: true,
          fireImmediately: true,
        },
      ),
      reaction(
        () => this.props.location && this.props.location.pathname,
        () => {
          // TODO Remove this isUnifiedBasket check once we update the other complex entry points (services and workers)
          if (this.props.location && this.props.location.pathname) {
            this.isUnifiedBasket = this.props.location.pathname === `/${i18n.lc}/` ||
              this.props.location.pathname.split('/').indexOf('lp5') !== -1 ||
              this.props.location.pathname.split('/').indexOf('treatments') !== -1;
          }
        },
        {
          name: 'Check if homepage when changing routes',
          compareStructural: true,
          fireImmediately: true,
        },
      ),
    ];
  }

  @observable isUnifiedBasket = false;

  render() {
    const {
      location: {
        query,
      },
      onOpenBasketPanel,
      userLoggedIn,
      basketItems,
    } = this.props;

    // We want to force the old flow in the e2e tests and all pages except homepage
    // TODO Remove when removing the ab test and toggles and doing final release of the booking flow
    if ((query && query.e2etest) || !this.isUnifiedBasket) {
      return (
        <React.Fragment>
          {basketItems && basketItems.length ? (
            <div className={cn(
              'site-header__basket-button-container',
              userLoggedIn && 'site-header__basket-button-container--signed-in',
            )}>
              <button
                className="site-header__basket-button"
                onClick={onOpenBasketPanel}
              >
                <img alt="" className="site-header__basket-button-icon" src={basketIcon} />
                <span className="site-header__basket-button-counter">{basketItems.length}</span>
              </button>
            </div>
          ) : null}
        </React.Fragment>
      );
    }

    return (
      <div className={cn(
        'site-header__basket-button-container',
        'site-header__basket-button-container-next',
        userLoggedIn && 'site-header__basket-button-container-next--signed-in',
      )}>
        <CartWithCountButton />
      </div>
    );
  }
}

export default HeaderBasketSectionWrapper;



// WEBPACK FOOTER //
// ./spa/Components/HeaderBasketSectionWrapper/HeaderBasketSectionWrapper.jsx